import { render, staticRenderFns } from "./Text.vue?vue&type=template&id=5e887b88&"
import script from "./Text.vue?vue&type=script&lang=js&"
export * from "./Text.vue?vue&type=script&lang=js&"
import style0 from "./Text.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e887b88')) {
      api.createRecord('5e887b88', component.options)
    } else {
      api.reload('5e887b88', component.options)
    }
    module.hot.accept("./Text.vue?vue&type=template&id=5e887b88&", function () {
      api.rerender('5e887b88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/conversation/bubble/Text.vue"
export default component.exports